import { MessageSearchTileComponent } from "../components/fragments/message-search-tile/message-search-tile.component";
import { SearchTileComponent } from "../components/fragments/search-tile/search-tile.component";
import { ResourceSearchTileComponent } from "../components/fragments/talent-core/resource-search-tile/resource-search-tile.component";
import { SearchRequestTypeEnum } from "../enums/search-request-type-enum";
import { SearchRequestType } from "../models/data/app-core/search-request-type";
import { SearchRequestEnvelope } from "../models/net/envelope/search-request-envelope";
import { ActingProfileSearchRequest } from "../models/net/request/acting-profile-search-request";
import { ClaimTypeSearchRequest } from "../models/net/request/claim-type-search-request";
import { ContactSearchRequest } from "../models/net/request/contact-search-request";
import { EmailMessageSearchRequest } from "../models/net/request/email-message-search-request";
import { EngagementSearchRequest } from "../models/net/request/engagement-search-request";
import { GroupSearchRequest } from "../models/net/request/group-search-request";
import { HtmlContentSearchRequest } from "../models/net/request/html-content-search-request";
import { MessageSearchRequest } from "../models/net/request/message-search-request";
import { OrganizationalUnitSearchRequest } from "../models/net/request/organizational-unit-search-request";
import { PersonSearchRequest } from "../models/net/request/person-search-request";
import { ProductSearchRequest } from "../models/net/request/product-search-request";
import { ProductionSearchRequest } from "../models/net/request/production-search-request";
import { ResourceSearchRequest } from "../models/net/request/resource-search-request";
import { RoleSearchRequest } from "../models/net/request/role-search-request";
import { SearchRequestSearchRequest } from "../models/net/request/search-request-search-request";
import { TextMessageSearchRequest } from "../models/net/request/text-message-search-request";
import { UserSearchRequest } from "../models/net/request/user-search-request";

export class TypeFactory {

    private constructor() { }

    private static typeRegistry: { [key: string]: any } = {
        SearchRequestEnvelope: SearchRequestEnvelope,
        SearchRequestSearchRequest: SearchRequestSearchRequest, 
        SearchTileComponent: SearchTileComponent,
        ClaimTypeSearchRequest: ClaimTypeSearchRequest,
        RoleSearchRequest: RoleSearchRequest,
        UserSearchRequest: UserSearchRequest,
        ResourceSearchRequest: ResourceSearchRequest,
        ResourceSearchTileComponent: ResourceSearchTileComponent,
        ActingProfileSearchRequest: ActingProfileSearchRequest,
        EngagementSearchRequest: EngagementSearchRequest,
        ProductionSearchRequest: ProductionSearchRequest,
        OrganizationalUnitSearchRequest: OrganizationalUnitSearchRequest,
        PersonSearchRequest: PersonSearchRequest,
        MessageSearchRequest: MessageSearchRequest,
        MessageSearchTileComponent: MessageSearchTileComponent,
        HtmlContentSearchRequest: HtmlContentSearchRequest,
        ProductSearchRequest: ProductSearchRequest
    };

    public static createInstance(typeName: string): any {

        let result: any | null = null;

        const type = TypeFactory.typeRegistry[typeName];

        if (type) {

            result = new type();

        } else {

            throw new Error(`Type ${typeName} not found in registry`);
        }

        return result;
    }

    public static resolveType(typeName: string): any {

        const result: any = TypeFactory.typeRegistry[typeName];

        if (!result) {

            throw new Error(`Type ${typeName} not found`);
        }

        return result;
    }

    public static convertSearchRequesTypeEnumToTypeArray(): SearchRequestType[] {

        const keys: string[] = Object.keys(SearchRequestTypeEnum).filter(key => isNaN(Number(key)));

        const result = keys.map(key => {
            const result = new SearchRequestType();
            const searchRequestTypeId: number = SearchRequestTypeEnum[key as keyof typeof SearchRequestTypeEnum];
            result.SearchRequestTypeId = searchRequestTypeId;
            result.UID = key;
            result.Description = key;
            result.CreatedOnUTC = new Date();
            result.CreateUserUID = "system";
            return result;
        });

        return result;
    }

    public static getGetTypedSearchRequestFromSearchRequestEnvelope = (searchRequestEnvelope: SearchRequestEnvelope, searchRequestTypeEnum: SearchRequestTypeEnum): any | null => {

        var result: any | null;

        switch (searchRequestTypeEnum) {

            case SearchRequestTypeEnum.ClaimTypeSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as ClaimTypeSearchRequest;

                break;

            case SearchRequestTypeEnum.RoleSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as RoleSearchRequest;

                break;

            case SearchRequestTypeEnum.UserSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as UserSearchRequest;

                break;

            case SearchRequestTypeEnum.SearchRequestSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as SearchRequestSearchRequest;

                break;

            case SearchRequestTypeEnum.ResourceSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as ResourceSearchRequest;

                break;

            case SearchRequestTypeEnum.ActingProfileSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as ActingProfileSearchRequest;

                break;

            case SearchRequestTypeEnum.EngagementSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as EngagementSearchRequest;

                break;

            case SearchRequestTypeEnum.ProductionSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as ProductionSearchRequest;

                break;

            case SearchRequestTypeEnum.OrganizationalUnitSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as OrganizationalUnitSearchRequest;

                break;

            case SearchRequestTypeEnum.PersonSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as PersonSearchRequest;

                break;

            case SearchRequestTypeEnum.GroupSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as GroupSearchRequest;

                break;

            case SearchRequestTypeEnum.MessageSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as MessageSearchRequest;

                break;

            case SearchRequestTypeEnum.ContactSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as ContactSearchRequest;

                break;

            case SearchRequestTypeEnum.HtmlContentSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as HtmlContentSearchRequest;

                break;

            case SearchRequestTypeEnum.EmailMessageSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as EmailMessageSearchRequest;

                break;

            case SearchRequestTypeEnum.TextMessageSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as TextMessageSearchRequest;

                break;

            case SearchRequestTypeEnum.ProductSearchRequest:

                result = JSON.parse(searchRequestEnvelope.Document.Item.SearchRequestJson) as ProductSearchRequest;

                break;

            default:

                result = null;

                break;
        }

        return result;
    }
}
